<template>
  <div style="margin:20px">
    <FiPageRail title="Driver Board" />

    <div style="font-size: 20px; font-weight: bold; position: relative; margin: 30px" class="d-flex align-items-center justify-content-center">
      <span v-if="base_options && base_options.length > 2" style="font-size: 20px; font-weight: bold;">
        Base: <b-form-select v-model="selected_base" :options="base_options" style="font-size: 20px; font-weight: bold;width:200px"/>
      </span>
      &nbsp;&nbsp;<b-button v-on:click.prevent="load_data()">Load</b-button>
    </div>

    <div v-if="items" class="row" style="margin: 20px 0px 25px 0px; font-weight: bold; font-size: 20px;">
      <div style="border: 2px solid grey;" class="col">{{items.length}} Results</div>
    </div>

    <br/>
    
    <div v-if="summary">
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields" :current-page="currentPage" style="font-size:20px" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
          </div>
        </template>

        <template slot="next_mvmt_driver" slot-scope="row">
          <template v-for="mvmt_driver in row.item.next_mvmt_driver">
            {{mvmt_driver}}
          </template>
        </template>

        <template slot="hos_on_time" slot-scope="row">
          <span v-if="row.item.hos_on_time">
            {{row.item.hos_on_time | formatDateTimeSmall}}
          </span>
          <span v-else="row.item.hos_status == 'late" style="color: darkred;">
            missing
          </span>
        </template>

        <template slot="start_time" slot-scope="row">
          {{row.item.start_time | formatDateTimeSmall}}
        </template>

        <template slot="finish_time" slot-scope="row">
          {{row.item.finish_time | formatDateTimeSmall}}
        </template>

        <template slot="next_mvmt_id" slot-scope="row">
          {{row.item.next_mvmt_id}}
          <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_id}}
          </template>
        </template>

        <template slot="next_mvmt_delta" slot-scope="row">
          <span v-if="row.item.next_mvmt_delta" :style="row.item.next_mvmt_delta.indexOf('d') != -1 ? '' : 'color: red'">
            {{row.item.next_mvmt_delta}}
          </span>
          <template v-if="row.item.next_mvmt_list" v-for="next_mvmt in row.item.next_mvmt_list">
            <br/>{{next_mvmt.next_mvmt_delta}}
          </template>
        </template>

      </b-table>
      <b-row v-if="items.length > 10">
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <div class="text-center text-danger my-2">
        <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>

import {get_driver_board} from "../networking/apis";
import {mapState} from "vuex";
import moment from 'moment';
import datetime from 'vuejs-datetimepicker';

export default {
  name: 'driver_board',
  components: {
     datetime
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      tenant_id: null,
      updating: false,
      reloading: false,
      items: [],
      base_options: [],
      selected_base: '',
      summary: null,
      loading: true,
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      pages: [],
      alert: {
        show: false,
        message: '',
        variant: ''
      },
      fields: [
        { key: 'driver', label: 'Driver', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'charterID', label: 'Charter ID', sortable: true, visible: true, thStyle: { width: "130px" }},
        { key: 'movementID', label: 'Mvmt ID', sortable: true, visible: true, thStyle: { width: "120px" }},
        { key: 'vehicle', label: 'Vehicle', sortable: true, visible: true, thStyle: { width: "100px" }},
        { key: 'hos_on_time', label: 'HOS On Time', sortable: true, visible: true, thStyle: { width: "160px" }},
        { key: 'start_base', label:'Start Base', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'start_time', label:'Start Time', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'finish_time', label:'Finish Time', sortable: true, visible: true, thStyle: { width: "140px" }},
        { key: 'pickup', label:'Pickup', sortable: true, visible: true, thStyle: { width: "250px" }},
        { key: 'destination', label:'Destination', sortable: true, visible: true, thStyle: { width: "250px" }},
      ],
    }
  },
  async created() {
    this.tenant_id = this.user.tenant
    this.fields_all = this.fields
    await this.check_features()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    showAlert(msg, variant, autoclose) {
      this.alert.show = true
      this.alert.message = msg
      this.alert.variant = variant
      autoclose
          ? setTimeout(() => this.closeAlert(), autoclose)
          : null
    },
    closeAlert() {
      this.alert.show = false
      this.alert.message = ''
      this.alert.variant = ''
    },
    async check_features() {
      this.load_data()
    },
    async load_data() {
      this.loading = true
      try {
        var results = await get_driver_board(this.tenant_id, this.selected_base)
        const {value: { data = [] } } = results

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.base_options = data.summary.base_options

      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    filter_results() {
      if (this.selected_base) {
        this.items = this.items.filter(item => this.contains(item.start_base, this.selected_base))
      }
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    }
  },
  computed: {
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    selected_base() {
      this.filter_results()
    },
  }
}
</script>

<style scoped>

div.row:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.header {
  font-weight: bold;
}

div.col {
  border: 1px solid grey;
}

.table td {
  padding: .1rem !important;
}

.mvmt-table td {
  vertical-align: middle !important;
}

div.wrap {
  border: 1px solid grey;
  flex-wrap: wrap;
  display: flex;
  inline-size: 150px;
  /* overflow-wrap: break-word; */
}

.stats { border-radius: 5px; margin:2px}
</style>

